import { render } from "./textList.vue?vue&type=template&id=968b3536"
import script from "./textList.vue?vue&type=script&lang=js"
export * from "./textList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__